export default "__VITE_ASSET__B5IM_6oc__"